import { isAnyOf } from '@reduxjs/toolkit';
import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';

const { actions: betslipActions, types: BetslipTypes } = MojitoServices.Betslip;
const reduxInstance = MojitoCore.Services.redux;

/**
 * Prebuilt analytics listener listen to redux actions and/or store changes. Used to track if
 * a prebuilt match acca is added to betslip and used to tell a regular match acca apart from a prebuilt match acca.
 *
 * @class PrebuiltAnalyticsListener
 * @memberof Mojito.Applications.Sports.Analytics
 */
class PrebuiltAnalyticsListener {
    constructor() {
        this.analyticListenersOptions = this.initializeListenersOptions();
    }

    initializeListenersOptions() {
        return [
            {
                actionCreator: betslipActions.addPartSuccess,
                effect: action => {
                    const { requestPayload } = action.payload;
                    const { bettingContext } = requestPayload || {};
                    // flag set to true when adding a prebuilt bet to Betslip.
                    this.isPrebuilt = bettingContext === BetslipTypes.BETTING_CONTEXT.PRE_BUILT_BET;
                },
            },
            {
                matcher: isAnyOf(
                    betslipActions.removePartSuccess,
                    betslipActions.removeCompositeSuccess,
                    betslipActions.clearBetslipSuccess
                ),
                effect: () => {
                    // flag set to false when modifying Betslip by adding, removing or clearing.
                    this.isPrebuilt = false;
                },
            },
        ];
    }

    /**
     * Initialize the prebuilt analytics listener.
     *
     * @function Mojito.Applications.Sports.Analytics.PrebuiltAnalyticsListener#init
     */
    init() {
        this.isPrebuilt = false;
        this.startListening();
    }

    /**
     * Dispose the prebuilt analytics listener.
     *
     * @function Mojito.Applications.Sports.Analytics.PrebuiltAnalyticsListener#dispose
     */
    dispose() {
        this.isPrebuilt = false;
        this.stopListening();
    }

    getPreBuiltStatus() {
        return this.isPrebuilt;
    }

    startListening() {
        this.analyticListenersOptions.forEach(options =>
            reduxInstance.actionListener.startListening(options)
        );
    }

    stopListening() {
        this.analyticListenersOptions.forEach(options =>
            reduxInstance.actionListener.stopListening(options)
        );
    }
}

export default new PrebuiltAnalyticsListener();
